/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  getMail: state => (emailId) => state.users.find((user) => user.id == emailId),
  getDomaine: state => (domaineId) => state.users.find((user) => user.domaine_id == domaineId)
  
}
